import { z } from "zod/v4";

export const CoreEnvObject = {
    appEnv: process.env.NODE_ENV,
    globalVendorNamespace: process.env.VITE_GLOBAL_VENDOR_NAMESPACE,
    globalAppNamespace: process.env.VITE_GLOBAL_APP_NAMESPACE,
    appUrl: `//${process.env.VITE_DOMAIN}`,
    demoMode: Number(process.env.VITE_DEMO_MODE) || 0,
} as const;

export const CoreConfigSchema = z.object({
    appEnv: z.enum(["development", "production", "test", ""]).default("production"),
    globalVendorNamespace: z.string().default("__HC__"),
    globalAppNamespace: z.string().default("ibe"),
    appUrl: z.string(),
    demoMode: z.number().int().min(0).default(0),
});

export type TCoreConfig = z.infer<typeof CoreConfigSchema>;
